var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNoConnectionIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 117,
    viewBox: "0 0 116 117",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3869_2472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.859 17.8442L87.4393 33.4168C58.9852 20.1513 25.1881 26.9282 2.20117 53.6035L10.1534 62.8316C28.6673 41.4915 55.2576 35.0029 78.6173 43.6543L69.4225 54.3244C51.53 49.9987 32.1464 55.9105 18.2299 72.204L26.1822 81.4322C35.2527 70.9063 47.3053 65.7155 59.358 66.148L45.69 82.009C41.4654 83.8835 37.6135 86.7673 34.1344 90.8046L36.1225 93.1116L21.709 109.549L26.0579 114.596L105.208 22.8909L100.859 17.8442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0391 109.261L57.9913 118.489L65.9436 109.261C61.5947 104.07 54.3879 104.07 50.0391 109.261Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7656 92.823C60.8481 91.2369 68.5518 93.6882 74.019 100.033L81.9713 90.8044C77.1254 85.1809 71.0369 81.5762 64.8242 80.1343L53.7656 92.823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8965 69.4643C79.7364 72.0597 85.2036 75.9528 89.9252 81.4321L97.8775 72.2039C93.2801 66.8688 88.0614 62.5431 82.47 59.5151L73.8965 69.4643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1187 40.1938L90.918 49.7104C96.2609 53.171 101.355 57.4967 105.953 62.8317L113.905 53.6036C109.308 48.4127 104.337 43.9428 99.1187 40.1938Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3869_2472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116,
    height: 116,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoConnectionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NoConnectionIcon.c9f0bbbe.svg";
export { ForwardRef as ReactComponent };